import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { getSafeReturnTo } from "../core/returnTo.js";
import { OnboardingFlow } from "../features/onboarding/OnboardingFlow.js";

/** A repeatable placement test that leaves language and learning path untouched. */
function PlacementPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const returnTo = getSafeReturnTo(searchParams.get("returnTo"), {
        blockedPaths: ["/onboarding", "/placement"]
    });
    const leave = useCallback(
        () => navigate(returnTo, { replace: true }),
        [navigate, returnTo]
    );

    return (
        <OnboardingFlow
            mode="retest"
            onCancel={leave}
            onComplete={leave}
        />
    );
}

export { PlacementPage };
